// Estonian translations (Eesti) - DEFAULT LANGUAGE
export const et = {
  nav: {
    about: 'Meist',
    packages: 'Paketid',
    technologies: 'Tehnoloogiad',
    services: 'Teenused',
    process: 'Protsess',
    contact: 'Kontakt',
    cta: 'Võta ühendust'
  },
  
  hero: {
    title1: 'AI Konsultatsioon',
    title2: 'Uue Ajastu',
    subtitle: 'Äriprotsesside automatiseerimine ja digitaalne transformatsioon',
    description: 'Loome intelligentseid ärisüsteeme AI abil. Strateegiast täieliku juurutamiseni.',
    ctaPrimary: 'Vali pakett',
    ctaSecondary: 'Konsultatsioon'
  },
  
  about: {
    title: 'Teie partner digitaalses transformatsioonis',
    paragraph1: 'Maailm kiireneb. Ettevõtted, kes juurutavad AI täna, saavad homme liidriteks.',
    paragraph2: 'Strateegiast täieliku juurutamiseni – loome intelligentseid ärisüsteeme mõõdetava tulemusega.',
    whyChoose: 'Miks meid valitakse',
    benefits: [
      {
        title: 'Täielik tsükkel — strateegiast juurutamiseni',
        description: 'Me ei konsulteeri lihtsalt — loome töötavaid lahendusi. Analüüsime, projekteerime, juurutame ja toetame tulemusteni.'
      },
      {
        title: 'Numbrid, mis tõestavad tulemust',
        description: 'Mõõdame kõike: aeg, efektiivsus, kasum. KPI, ROI ja BI-analüütika näitab, kuidas AI teeb teie äri kiiremaks, täpsemaks ja kasumlikumaks.'
      },
      {
        title: 'AI — tööriist, mitte tulevik',
        description: 'Juurutame tehnoloogiaid, mis juba täna toovad äri kasumit — automatiseerimisest andmepõhise analüütikani.'
      },
      {
        title: 'Rahvusvaheline kogemus ja paindlikkus',
        description: 'Asume Eestis, töötame klientidega üle maailma. Kohandame lahendusi erinevatele turgudele ja mastaapidele.'
      },
      {
        title: 'Partnerlus, mitte alltöövõtt',
        description: 'Me pole lihtsalt konsultandid — ühendame teie meeskonnaga ja viime projekti märgatava tulemuseni.'
      }
    ]
  },
  
  packages: {
    title: 'Lahendused digitaalseks kasvuks',
    subtitle: 'Strateegiast automatiseerimise ja AI juurutamiseni',
    popular: 'Populaarne',
    learnMore: 'Lisateave',
    result: 'Tulemus:',
    items: [
      {
        name: 'INSIGHT',
        icon: '🔴',
        tagline: 'Analüüs ja kasvu strateegia',
        price: '€1 500 - €2 500',
        description: 'Väikeste ja keskmiste ettevõtete, startupide jaoks',
        features: [
          'Täielik äri- ja protsessiaudit',
          'Konkurentide ja digitaalse küpsuse analüüs',
          'SWOT-analüüs ja kasvupunktide kaart',
          'AI ja automatiseerimise soovitused',
          'Mini-strateegia 3 kuuks',
          'Strateegiline sessioon (90 min)'
        ],
        result: 'Arusaam, kus äri kaotab raha, ja selge kasvuplaan'
      },
      {
        name: 'GROWTH ENGINE',
        icon: '🔵',
        tagline: 'Süsteemne kasv ja automatiseerimine',
        price: '€4 500 - €9 000',
        description: 'Üleminek süsteemsele kasvule ja digitaliseerimine',
        features: [
          'Kõik INSIGHT paketist',
          'Strateegia 6 kuuks',
          'CRM / ERP süsteemide juurutamine',
          'AI chatbotid ja autolehtrid',
          'Läbiv analüütika ja BI armatuurlauad',
          'HR konsultatsioon ja KPI juurutamine',
          '3 kuu tugi'
        ],
        result: 'Stabiilne kasv, läbipaistev juhtimine, protsesside automatiseerimine',
        popular: true
      },
      {
        name: 'AI TRANSFORM',
        icon: '🟣',
        tagline: 'Äri digitaalne transformatsioon',
        price: '€12 000 - €30 000',
        description: 'Keskmiste ja suurte ettevõtete jaoks',
        features: [
          'Kõik GROWTH ENGINE paketist',
          'Aastane Digital & AI tegevuskava',
          'Kompleksne protsesside automatiseerimine',
          'AI lahenduste juurutamine',
          'IT-infrastruktuuri moderniseerimine',
          'Personali koolitus',
          'Individuaalne projekti kuraator'
        ],
        result: 'Täielik AI transformatsioon: skaleeritav andmepõhine ökosüsteem'
      },
      {
        name: 'PROJECT+',
        icon: '⚫',
        tagline: 'Individuaalsed lahendused',
        price: 'alates €5 000',
        description: 'Kohandatud võtmed kätte projektid',
        features: [
          'AI botid ja assistendid',
          'CRM/ERP automatiseerimine',
          'SaaS või turuplatsi loomine',
          'BI analüütika ja prognoosimine',
          'Investeeringuteks ettevalmistamine',
          'AI integreerimine protsessidesse'
        ],
        result: 'Valmis lahendus, kohandatud teie eesmärkidele ja mastaabile'
      }
    ]
  },
  
  technologies: {
    title: 'Tehnoloogiad ja tööriistad',
    subtitle: 'Tipptasemel automatiseerimine lahendused',
    items: [
      {
        title: 'Tehisintellekt',
        description: 'Machine Learning, NLP, arvutinägemine, ennustav analüütika',
        keywords: ['ChatGPT', 'Claude', 'Gemini', 'Kohandatud AI']
      },
      {
        title: 'Protsesside automatiseerimine',
        description: 'RPA, workflow automation, API integratsioonid, äriprotsessid',
        keywords: ['Make', 'Zapier', 'n8n', 'Kohandatud skriptid']
      },
      {
        title: 'CRM & ERP süsteemid',
        description: 'Juurutamine, seadistamine ja juhtimissüsteemide optimeerimine',
        keywords: ['Bitrix24', 'Salesforce', 'SAP', '1C']
      },
      {
        title: 'BI & Analüütika',
        description: 'Business Intelligence, armatuurlauad, andmete visualiseerimine',
        keywords: ['Power BI', 'Tableau', 'Looker', 'Kohandatud']
      }
    ]
  },
  
  services: {
    title: 'Meie suunad',
    subtitle: 'Komplekssed lahendused äri kasvuks',
    items: [
      { title: 'Ärikonsultatsioon', description: 'Strateegiline planeerimine, protsesside optimeerimine, kasumi suurendamine' },
      { title: 'Digitaalne transformatsioon', description: 'Äri digitaliseerimine, kaasaegsete tehnoloogiate juurutamine, skaleerimine' },
      { title: 'Finantskonsultatsioon', description: 'Finantsanalüüs, kulude optimeerimine, planeerimine ja riskijuhtimine' },
      { title: 'Juriidiline tugi', description: 'Äriõigus, lepingud, GDPR, rahvusvaheline seadusandlus' },
      { title: 'HR konsultatsioon', description: 'Personalijuhtimine, KPI, meeskonna motivatsioon, talentide arendamine' },
      { title: 'Automatiseerimine', description: 'Äriprotsesside automatiseerimine, integratsioonid, efektiivsuse tõstmine' },
      { title: 'AI & ML juurutamine', description: 'Tehisintellekt äris, analüütika, prognoosimine, chatbotid' }
    ]
  },
  
  whyUs: {
    title: 'Tulemused, mis räägivad ise',
    subtitle: 'Meie efektiivsuse numbrid',
    items: [
      { prefix: 'kuni', number: '92%', title: 'Efektiivsuse kasv', description: 'Keskmine tootlikkuse kasv pärast meie lahenduste juurutamist' },
      { prefix: 'kuni', number: '6 kuu', title: 'Tasuvus', description: 'Keskmine investeeringute tagasituleku aeg automatiseerimisse ja AI-sse' },
      { number: '24/7', title: 'Tugi', description: 'Tehniline tugi ja konsultatsioonid kõigil etappidel' },
      { prefix: '> ', number: '50', title: 'Projekti', description: 'Edukalt elluviidud AI ja automatiseerimine projekte' }
    ]
  },
  
  process: {
    title: 'Tööprotsess',
    subtitle: 'Analüüsist tulemuseni',
    items: [
      { number: '01', title: 'Analüüs ja audit', description: 'Põhjalik äri, protsesside ja süsteemide analüüs' },
      { number: '02', title: 'Strateegia', description: 'Tegevuskava ja digitaalse transformatsiooni plaani väljatöötamine' },
      { number: '03', title: 'Juurutamine', description: 'Järkjärguline AI, automatiseerimise ja juhtimissüsteemide juurutamine' },
      { number: '04', title: 'Koolitus', description: 'Personali koolitus uute tehnoloogiatega töötamiseks' },
      { number: '05', title: 'Optimeerimine', description: 'Pidev täiustamine ja lahenduste skaleerimine' }
    ]
  },
  
  contact: {
    title: 'Võta meiega ühendust',
    subtitle: 'Valmis alustama oma äri transformatsiooni?',
    selectedPackage: 'Valitud pakett:',
    goalQuestion: 'Mis on teie päringu peamine eesmärk?',
    goals: ['Protsesside automatiseerimine', 'AI juurutamine', 'Efektiivsuse tõstmine', 'Konsultatsioon'],
    multipleChoice: 'Võid valida mitu varianti',
    form: {
      name: 'Nimi *',
      email: 'E-post *',
      company: 'Ettevõtte nimi *',
      companyDescription: 'Lühike kirjeldus ettevõtte tegevusest *',
      message: 'Lisasõnum (valikuline)',
      terms: 'Olen tutvunud ja nõustun',
      termsLink: 'kasutustingimustega',
      and: 'ja',
      privacyLink: 'privaatsuspoliitikaga',
      termsNote: '*. Tellides teenuseid mis tahes kanalit pidi (e-post, telefon jne), nõustute automaatselt meie kasutustingimustega.',
      submit: 'Saada sõnum',
      submitting: 'Saadan...',
      success: 'Aitäh! Võtame teiega peagi ühendust.',
      error: 'Ilmnes viga. Palun proovige hiljem uuesti.'
    }
  },
  
  footer: {
    description: 'Uue põlvkonna konsultatsioon. AI, automatiseerimine ja äri digitaalne transformatsioon.',
    company: 'Polyus Plus OÜ',
    navigation: 'Navigeerimine',
    legal: 'Õiguslik teave',
    links: {
      about: 'Meist',
      packages: 'Paketid',
      services: 'Teenused',
      contact: 'Võta ühendust',
      terms: 'Kasutustingimused',
      privacy: 'Privaatsuspoliitika',
      cookie: 'Küpsiste poliitika',
      cookieSettings: 'Küpsiste seaded'
    },
    rights: 'Kõik õigused kaitstud.',
    keywords: 'AI konsultatsioon | Äri automatiseerimine | Digitaalne transformatsioon'
  },
  
  cookie: {
    title: '🍪 Küpsiste teade',
    description: 'Kasutame küpsiseid teie sirvimiskogemuse parandamiseks ja analüütikaks.',
    accept: 'Nõustun',
    decline: 'Keeldun',
    settings: 'Seaded',
    moreDetails: 'Rohkem infot →',
    settingsModal: {
      title: 'Küpsiste seaded',
      subtitle: 'Valige, millised küpsised lubada',
      alwaysEnabled: 'Alati sisse',
      saveSettings: 'Salvesta seaded',
      acceptAll: 'Nõustu kõigiga',
      categories: {
        essential: {
          name: 'Vajalikud küpsised',
          description: 'Need küpsised on veebisaidi toimimiseks vajalikud ega saa neid välja lülitada.'
        },
        analytics: {
          name: 'Analüütilised küpsised',
          description: 'Google Analytics 4, Hotjar - aitavad mõista, kuidas külastajad saiti kasutavad.'
        },
        marketing: {
          name: 'Turundusküpsised',
          description: 'Meta Pixel, TikTok Pixel - kasutatakse sihitud reklaamiks.'
        },
        functional: {
          name: 'Funktsionaalsed küpsised',
          description: 'Parandavad saidi funktsionaalsust (keele, teema salvestamine jne).'
        }
      }
    }
  },
  
  // Meta and SEO
  meta: {
    title: 'Polyus Plus | AI Konsultatsioon ja Äri Automatiseerimine Tallinnas, Eestis',
    description: 'Professionaalne AI konsultatsioon, äriprotsesside automatiseerimine ja digitaalne transformatsioon. Tehisintellekti rakendamine, efektiivsuse kasv kuni 92%, läbipaistev ROI. Konsultatsioon Tallinnas, töötame üle maailma.',
    keywords: 'AI konsultatsioon, äri automatiseerimine, digitaalne transformatsioon, AI rakendamine, äriprotsessid, konsultatsioon Eesti, Tallinn, tehisintellekt, KPI, ROI, äri efektiivsus, Google Analytics 4, Hotjar, Facebook Pixel',
    ogTitle: 'Polyus Plus | AI Konsultatsioon ja Äri Automatiseerimine',
    ogDescription: 'Professionaalne AI konsultatsioon, äriprotsesside automatiseerimine ja digitaalne transformatsioon. Efektiivsuse kasv kuni 92%, läbipaistev ROI.',
    siteName: 'Polyus Plus',
    footer: {
      company: 'Ettevõttest',
      about: 'Meist',
      packages: 'Paketid',
      services: 'Teenused',
      contact: 'Võta ühendust',
      terms: 'Kasutustingimused',
      privacy: 'Privaatsuspoliitika',
      cookie: 'Küpsiste poliitika',
      cookieSettings: 'Küpsiste seaded'
    },
    rights: 'Kõik õigused kaitstud.'
  }
};
